import Loading from "../../components/loading";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import RankIcon from "../../components/rank-icon";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import NoData from "../../components/no-data";

const TournamentLeaderboard = props => {
    const {t} = useTranslation()
    const {uuid} = props;
    const [loading, setLoading] = useState(true)
    const [list, setList] = useState([])

    // todo get tournament sort !
    useEffect(() => {
        if (uuid) {
            console.log('11=', uuid)
            associateServices.getTournamentLeaderboard({uuid})
                .then(res => {
                    setList(res?.data)
                    setLoading(false)
                })
        }
    }, [uuid])

    const [searchParams, setSearchParams] = useSearchParams()
    const handleUserDetail = sort => {
        searchParams.append('modal', 'statistics')
        searchParams.append('user', sort?.customer?.username)

        setSearchParams(searchParams)

    }


    if (loading)
        return <div style={{
            minHeight: 280
        }}>
            <Loading/>
        </div>
    return (
        <div className="table-responsive">
            {

                list?.length <= 0 ?
                    <div className={'col-12 d-flex align-items-center justify-content-center'}

                         style={{
                             minHeight: 280
                         }}
                    ><NoData/></div> :
                    <table className="xtable xtable--small">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{t('tournaments.username')}</th>
                            <th>{t('tournaments.prize')}</th>
                        </tr>
                        </thead>
                        <tbody>

                        {

                            list?.map((item, i) => (
                                <tr key={item.customer_id}>
                                    <td>
                                        <div className="xtable__text xtable__text--grey">
                                            {i + 1}
                                        </div>
                                    </td>
                                    <td onClick={e => handleUserDetail(item)}>
                            <span className="chat__user">
                              <RankIcon icon={item?.customer?.ranki}/>
                              <button className="chat__name" type="button">
                                {item?.customer?.is_public ? item?.customer?.username : item?.customer?.masked_username}
                              </button>
                            </span>
                                    </td>
                                    <td>
                                        <div className="xtable__text xtable__text--green">
                                            ${item?.prize}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }

                        </tbody>
                    </table>
            }
        </div>
    )


}

export default TournamentLeaderboard
